export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CurrencyScalar: any;
  Long: any;
  Percent: any;
  /** in ISO-8601 extended offset date-time format (e.g. '2011-12-03T10:15:30+01:00' or '2018-01-25T15:20:05Z' for UTC time zone) */
  ZonedDateTime: any;
};

export type AbroadBankingDetail = {
  __typename?: 'AbroadBankingDetail';
  bankAddress: Scalars['String'];
  bankCity?: Maybe<Scalars['String']>;
  bankCountry?: Maybe<Scalars['String']>;
  bankName: Scalars['String'];
  bankSwift?: Maybe<Scalars['String']>;
  /** ISO local date */
  birthday?: Maybe<Scalars['String']>;
  clientHomeAddress: Scalars['String'];
  clientName: Scalars['String'];
  iban: Scalars['String'];
};

export type AlfaBankAccountDetail = {
  __typename?: 'AlfaBankAccountDetail';
  accountNumber: Scalars['String'];
};

export type AuditInfoV2 = {
  __typename?: 'AuditInfoV2';
  createdAt: Scalars['ZonedDateTime'];
  createdBy?: Maybe<User>;
  updatedAt: Scalars['ZonedDateTime'];
  updatedBy?: Maybe<User>;
};

export type BhnUserCardsRequestV2 = {
  /** В случае если isArchived == true, возвращаются карточки с флагом isArchived == true, у которых флаг hasFilledOrders == true */
  isArchived?: Maybe<Scalars['Boolean']>;
};

export type Billing = {
  __typename?: 'Billing';
  mainAccountDetails?: Maybe<BillingMainAccountDetailsPage>;
  tradingAccountDetails?: Maybe<BillingTradingAccountDetailsPage>;
};

export type BillingMainAccountDetailsArgs = {
  currency: Scalars['CurrencyScalar'];
  dates?: Maybe<DateTimeRangeV2>;
  pageRequest?: Maybe<PageRequestWithoutSortV2>;
};

export type BillingTradingAccountDetailsArgs = {
  dates?: Maybe<DateTimeRangeV2>;
  market: Scalars['String'];
  pageRequest?: Maybe<PageRequestWithoutSortV2>;
};

export type BillingAccount = {
  __typename?: 'BillingAccount';
  /** Effectively not null. */
  amount?: Maybe<MoneyV2>;
  /** Effectively not null. */
  auditInfo?: Maybe<AuditInfoV2>;
  /** Effectively not null. */
  detail?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** Effectively not null. */
  type?: Maybe<BillingAccountType>;
  /** Effectively not null. */
  typedDetail?: Maybe<BillingDetail>;
};

export enum BillingAccountType {
  AnswrPayout = 'ANSWR_PAYOUT',
  BrokerFeesOnMarket = 'BROKER_FEES_ON_MARKET',
  ConvertFromUser = 'CONVERT_FROM_USER',
  ConvertToUser = 'CONVERT_TO_USER',
  Correction = 'CORRECTION',
  DepositCommission = 'DEPOSIT_COMMISSION',
  ExchangeFeesOnMarket = 'EXCHANGE_FEES_ON_MARKET',
  ExchangeFeesOnMarketRebatesSource = 'EXCHANGE_FEES_ON_MARKET_REBATES_SOURCE',
  InvestmentEarlyLeaveCommission = 'INVESTMENT_EARLY_LEAVE_COMMISSION',
  InvestmentLeaveCommission = 'INVESTMENT_LEAVE_COMMISSION',
  InvestmentLoss = 'INVESTMENT_LOSS',
  InvestmentManagementCommission = 'INVESTMENT_MANAGEMENT_COMMISSION',
  InvestmentProfit = 'INVESTMENT_PROFIT',
  InvestmentStartCommission = 'INVESTMENT_START_COMMISSION',
  InvestmentSuccessCommission = 'INVESTMENT_SUCCESS_COMMISSION',
  ManagerPayout = 'MANAGER_PAYOUT',
  OvernightFeesOnMarket = 'OVERNIGHT_FEES_ON_MARKET',
  PartnerPayout = 'PARTNER_PAYOUT',
  PaymentSystemFrom = 'PAYMENT_SYSTEM_FROM',
  PaymentSystemTo = 'PAYMENT_SYSTEM_TO',
  Purchase = 'PURCHASE',
  TokensOutgoing = 'TOKENS_OUTGOING',
  TournamentsReward = 'TOURNAMENTS_REWARD',
  TradingLossForMarket = 'TRADING_LOSS_FOR_MARKET',
  TradingOnMarket = 'TRADING_ON_MARKET',
  TradingPlatformFeesOnMarket = 'TRADING_PLATFORM_FEES_ON_MARKET',
  TradingProfitForMarket = 'TRADING_PROFIT_FOR_MARKET',
  User = 'USER',
  UserInvestment = 'USER_INVESTMENT',
  UserInvestmentPrepared = 'USER_INVESTMENT_PREPARED',
  UserMoneyPosition = 'USER_MONEY_POSITION',
  UserWithdrawPrepared = 'USER_WITHDRAW_PREPARED',
  UtexBankruptcy = 'UTEX_BANKRUPTCY',
  UtexDeposit = 'UTEX_DEPOSIT',
  UtexMarginDepositTransit = 'UTEX_MARGIN_DEPOSIT_TRANSIT',
  UtexMarginWithdrawTransit = 'UTEX_MARGIN_WITHDRAW_TRANSIT',
  UtexMarketingExpenses = 'UTEX_MARKETING_EXPENSES',
  UtexWithdraw = 'UTEX_WITHDRAW',
  WithdrawCommission = 'WITHDRAW_COMMISSION',
}

/** Alter name: BillingAccountDetail */
export type BillingDetail =
  | BillingIdeaDetail
  | BillingRawDetail
  | BillingStockDetail
  | BillingUserAndIdeaDetail
  | BillingUserAndMarketDetail
  | BillingUserAndStockDetail
  | BillingUserDetail;

/** Alter name: BillingIdeaAccountDetail */
export type BillingIdeaDetail = {
  __typename?: 'BillingIdeaDetail';
  /**
   * we don't have common type, which is extended by bnh, limited, unlimited ideas.
   * As result, we don't have common (pass-through) id
   */
  ideaId: Scalars['ID'];
};

export type BillingMainAccountCancelClearingWithdraw = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountCancelClearingWithdraw';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  operationAmount: MoneyV2;
  withdrawRequest: ClearingWithdrawRequest;
};

export type BillingMainAccountCancelInvestment = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountCancelInvestment';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  /** in some corner cases we don't have information about idea */
  idea?: Maybe<InvestmentRegistryIdea>;
  operationAmount: MoneyV2;
};

/** clearing */
export type BillingMainAccountClearingDeposit = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountClearingDeposit';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  operationAmount: MoneyV2;
};

export type BillingMainAccountClearingWithdraw = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountClearingWithdraw';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  operationAmount: MoneyV2;
  withdrawRequest: ClearingWithdrawRequest;
};

/** correction */
export type BillingMainAccountCorrection = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountCorrection';
  balanceAfterOperation: MoneyV2;
  correction: ClearingCorrection;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  operationAmount: MoneyV2;
};

/** currency conversion */
export type BillingMainAccountCurrencyConversion = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountCurrencyConversion';
  balanceAfterOperation: MoneyV2;
  conversion?: Maybe<ClearingConversion>;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  operationAmount: MoneyV2;
};

export type BillingMainAccountDetailsItem =
  | BillingMainAccountCancelClearingWithdraw
  | BillingMainAccountCancelInvestment
  | BillingMainAccountClearingDeposit
  | BillingMainAccountClearingWithdraw
  | BillingMainAccountCorrection
  | BillingMainAccountCurrencyConversion
  | BillingMainAccountFinishInvestment
  | BillingMainAccountIco
  | BillingMainAccountPartnerProfit
  | BillingMainAccountPurchase
  | BillingMainAccountReturnUnusedInvestment
  | BillingMainAccountRevert
  | BillingMainAccountStartInvestment
  | BillingMainAccountTransferFromAurora
  | BillingMainAccountTransferFromUtex
  | BillingMainAccountTransferToAurora
  | BillingMainAccountTransferToUtex;

export type BillingMainAccountDetailsItemInterface = {
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  operationAmount: MoneyV2;
};

export type BillingMainAccountDetailsPage = PagedResponseV2 & {
  __typename?: 'BillingMainAccountDetailsPage';
  content: Array<BillingMainAccountDetailsItem>;
  pageInfo: PageInfoV2;
};

export type BillingMainAccountFinishInvestment = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountFinishInvestment';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  idea?: Maybe<InvestmentRegistryIdea>;
  operationAmount: MoneyV2;
};

/** ico */
export type BillingMainAccountIco = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountICO';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  operationAmount: MoneyV2;
};

/** affiliate */
export type BillingMainAccountPartnerProfit = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountPartnerProfit';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  operationAmount: MoneyV2;
};

/** actual user only by education (depreacted service) */
export type BillingMainAccountPurchase = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountPurchase';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  operationAmount: MoneyV2;
};

export type BillingMainAccountReturnUnusedInvestment = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountReturnUnusedInvestment';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  idea?: Maybe<InvestmentRegistryIdea>;
  operationAmount: MoneyV2;
};

export type BillingMainAccountRevert = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountRevert';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  operationAmount: MoneyV2;
};

/** investment & stocks */
export type BillingMainAccountStartInvestment = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountStartInvestment';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  /** in some corner cases we don't have information about idea */
  idea?: Maybe<InvestmentRegistryIdea>;
  operationAmount: MoneyV2;
};

export type BillingMainAccountTransferFromAurora = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountTransferFromAurora';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  market: Scalars['String'];
  operationAmount: MoneyV2;
};

export type BillingMainAccountTransferFromUtex = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountTransferFromUtex';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  operationAmount: MoneyV2;
};

/** aurora */
export type BillingMainAccountTransferToAurora = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountTransferToAurora';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  market: Scalars['String'];
  operationAmount: MoneyV2;
};

/** utex */
export type BillingMainAccountTransferToUtex = BillingMainAccountDetailsItemInterface & {
  __typename?: 'BillingMainAccountTransferToUtex';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  operationAmount: MoneyV2;
};

/** Alter name: BillingAccountRawDetail. For other account types */
export type BillingRawDetail = {
  __typename?: 'BillingRawDetail';
  content: Scalars['String'];
};

/** Alter name: BillingStockAccountDetail */
export type BillingStockDetail = {
  __typename?: 'BillingStockDetail';
  stock: StockV2;
};

export type BillingTradingAccountCorrection = BillingTradingAccountDetailsItemInterface & {
  __typename?: 'BillingTradingAccountCorrection';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  market: Scalars['String'];
  operationAmount: MoneyV2;
};

export type BillingTradingAccountDeposit = BillingTradingAccountDetailsItemInterface & {
  __typename?: 'BillingTradingAccountDeposit';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  market: Scalars['String'];
  operationAmount: MoneyV2;
};

export type BillingTradingAccountDetailsItem =
  | BillingTradingAccountCorrection
  | BillingTradingAccountDeposit
  | BillingTradingAccountPnl
  | BillingTradingAccountTradingFeeChargeOff
  | BillingTradingAccountWithdraw;

export type BillingTradingAccountDetailsItemInterface = {
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  market: Scalars['String'];
  operationAmount: MoneyV2;
};

export type BillingTradingAccountDetailsPage = PagedResponseV2 & {
  __typename?: 'BillingTradingAccountDetailsPage';
  content: Array<BillingTradingAccountDetailsItem>;
  pageInfo: PageInfoV2;
};

export type BillingTradingAccountPnl = BillingTradingAccountDetailsItemInterface & {
  __typename?: 'BillingTradingAccountPnl';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  market: Scalars['String'];
  operationAmount: MoneyV2;
};

export type BillingTradingAccountTradingFeeChargeOff = BillingTradingAccountDetailsItemInterface & {
  __typename?: 'BillingTradingAccountTradingFeeChargeOff';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  market: Scalars['String'];
  operationAmount: MoneyV2;
};

export type BillingTradingAccountWithdraw = BillingTradingAccountDetailsItemInterface & {
  __typename?: 'BillingTradingAccountWithdraw';
  balanceAfterOperation: MoneyV2;
  date: Scalars['ZonedDateTime'];
  description: Scalars['String'];
  market: Scalars['String'];
  operationAmount: MoneyV2;
};

/** Alter name: BillingUserAndIdeaAccountDetail */
export type BillingUserAndIdeaDetail = {
  __typename?: 'BillingUserAndIdeaDetail';
  ideaId: Scalars['ID'];
  user: User;
};

/** Alter name: BillingTradingAccountDetail */
export type BillingUserAndMarketDetail = {
  __typename?: 'BillingUserAndMarketDetail';
  marketName: Scalars['String'];
  user: User;
};

/** Alter name: BillingUserAndStockAccountDetail */
export type BillingUserAndStockDetail = {
  __typename?: 'BillingUserAndStockDetail';
  stock: StockV2;
  user: User;
};

/** Alter name: BillingUserAccountDetail */
export type BillingUserDetail = {
  __typename?: 'BillingUserDetail';
  user: User;
};

export type BnH = {
  __typename?: 'BnH';
  /** Список завершенных pre-IPO. */
  finishedPreIPOIdeas: Array<BnHFinishedPreIpoIdea>;
  idea?: Maybe<BnHIdeaV2>;
  ideas: Array<BnHIdeaV2>;
  /** Список не завершенных pre-IPO */
  nonFinishedPreIPOIdeas: Array<BnHNonFinishedPreIpoIdea>;
  positionsSummary?: Maybe<BnHPositionsSummary>;
  userCard?: Maybe<BnHUserCardV2>;
  userCards?: Maybe<Array<BnHUserCardV2>>;
};

export type BnHIdeaArgs = {
  id: Scalars['ID'];
};

export type BnHIdeasArgs = {
  filter?: Maybe<BnHIdeasFilter>;
};

export type BnHUserCardArgs = {
  id: Scalars['ID'];
};

export type BnHUserCardsArgs = {
  request: BhnUserCardsRequestV2;
};

export type BnHBuyOrderFeeV2 = {
  __typename?: 'BnHBuyOrderFeeV2';
  enterFee: MoneyV2;
  enterFeePercent: Scalars['Percent'];
};

export type BnHChartPointV2 = {
  __typename?: 'BnHChartPointV2';
  close: Scalars['Float'];
  date: Scalars['ZonedDateTime'];
  high: Scalars['Float'];
  low: Scalars['Float'];
  open: Scalars['Float'];
  volume: Scalars['Float'];
};

export type BnHChartRequestV2 = {
  from: Scalars['ZonedDateTime'];
  to: Scalars['ZonedDateTime'];
};

export type BnHChartV2 = {
  __typename?: 'BnHChartV2';
  points: Array<BnHChartPointV2>;
};

export type BnHFinishedPreIpoIdea = {
  __typename?: 'BnHFinishedPreIpoIdea';
  /** Цена закрытия Pre-IPO */
  closePrice?: Maybe<MoneyV2>;
  idea: BnHIdeaV2;
  /** PnL с учетом актуальных комиссий */
  pnl: Scalars['Percent'];
};

export enum BnHIdeaRiskLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export type BnHIdeaV2 = {
  __typename?: 'BnHIdeaV2';
  buyDisabled: Scalars['Boolean'];
  category: Scalars['String'];
  chart: BnHChartV2;
  /** depends on Accept-Language http header */
  chartDescriptionLocalized: Scalars['String'];
  /** depends on Accept-Language http header */
  descriptionLocalized: Scalars['String'];
  fees?: Maybe<BnhIdeaFeeV2>;
  finishDate?: Maybe<Scalars['ZonedDateTime']>;
  /** Цена входа в Pre-IPO на старте */
  firstOfferPrice?: Maybe<MoneyV2>;
  /** depends on Accept-Language http header */
  fullDescriptionLocalized: Scalars['String'];
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
  isFinished: Scalars['Boolean'];
  /** Порядок идеи в публичном списке всех идей (глобально уникален в рамках limited, unlimited, bnh). Чем больше число - тем выше должна быть идея в списке. */
  listIndex: Scalars['Long'];
  logoUrl: Scalars['String'];
  marketData: BnHMarketDataV2;
  /** минимальная сумма для покупки */
  minAmount: MoneyV2;
  /** минимальное количество доступное для продажи */
  minSellQty: Scalars['Float'];
  name: Scalars['String'];
  /** прогнозируемый доход */
  profit: Scalars['Percent'];
  promoChart?: Maybe<BnHPromoChart>;
  publishDate: Scalars['ZonedDateTime'];
  /** шаг количества при покупке/продаже бумаги */
  qtyStep: Scalars['Float'];
  riskLevel: BnHIdeaRiskLevel;
  sellDisabled: Scalars['Boolean'];
  startDate?: Maybe<Scalars['ZonedDateTime']>;
  ticker?: Maybe<Scalars['String']>;
};

export type BnHIdeaV2ChartArgs = {
  request: BnHChartRequestV2;
};

export type BnHIdeaV2FeesArgs = {
  amount: MoneyInputV2;
};

export type BnHIdeasFilter = {
  categories?: Maybe<Array<Scalars['String']>>;
};

export type BnHMarketDataV2 = {
  __typename?: 'BnHMarketDataV2';
  /** цена по которой юзер может продать */
  ask?: Maybe<MoneyV2>;
  bid?: Maybe<MoneyV2>;
};

export type BnHNonFinishedPreIpoIdea = {
  __typename?: 'BnHNonFinishedPreIpoIdea';
  /** Цена на данный момент */
  currentPrice?: Maybe<MoneyV2>;
  idea: BnHIdeaV2;
  /** PnL без учета комиссий */
  pnl: Scalars['Percent'];
};

export type BnHOrderExecutedPartV2 = {
  __typename?: 'BnHOrderExecutedPartV2';
  /**
   * движение по средств по счету. сумма операции которую investment отправил в биллинг
   * для полностью не исполненного BUY|SELL = 0
   * для частично исполненного BUY - сумма, которая спиалась в биллинге и не может быть возвращена в результате отмены ордера
   * для частично исполненного SELL - сумма начисленная в биллинге в результате продажи части ордера
   */
  accountMovement: MoneyV2;
  /** средневзвешенная цена исполнения по этому ордеру */
  executedPrice?: Maybe<MoneyV2>;
  /** комиссия которые взяты с пользователя (начисленны на соответсвуюзие счета в биллинге) */
  fees: BnHOrderFeeV2;
  qty: Scalars['Float'];
};

export type BnHOrderFeeV2 = BnHBuyOrderFeeV2 | BnHSellOrderFeeV2;

export type BnHOrderNotExecutedPartV2 = {
  __typename?: 'BnHOrderNotExecutedPartV2';
  /**
   * движение по средств по счету. сумма операции которую investment отправил в биллинг
   * для полностью исполненного BUY|SELL = 0
   * для частично исполненного BUY - сумма резерва в биллинге, которая вернется на счет в случае отмены ордера
   * для частично исполненного SELL - сумма которая потенциально начислиться в биллинге если остаток ордера исполнится
   */
  accountMovement: MoneyV2;
  /** в случае если ордер CANCEL|REJECT = 0. Если Open = сумма комиссии, которую мы возьмем с пользователя */
  fees: BnHOrderFeeV2;
  /** предполагаемая стоимость одной акции. Не определено для buy ордера и равно 0 */
  price: MoneyV2;
  /** количество. Не определено для buy ордера и равно 0 */
  qty: Scalars['Float'];
};

export type BnHOrderRejectReasonV2 = {
  __typename?: 'BnHOrderRejectReasonV2';
  /** ключ локализации или свободное сообщение */
  code: Scalars['String'];
  /** параметры для локализации формализованного сообщения */
  params?: Maybe<Array<Maybe<MapItem>>>;
};

export enum BnHOrderStatusV2 {
  Canceled = 'CANCELED',
  Filled = 'FILLED',
  Opened = 'OPENED',
  Rejected = 'REJECTED',
  RejectedAndAcknowledged = 'REJECTED_AND_ACKNOWLEDGED',
}

export type BnHOrderV2 = {
  __typename?: 'BnHOrderV2';
  card: BnHUserCardV2;
  createdDate: Scalars['ZonedDateTime'];
  executedPart: BnHOrderExecutedPartV2;
  id: Scalars['ID'];
  /** Если по ордеру не было ни одного сведения - равна createdDate */
  lastExecutionDate: Scalars['ZonedDateTime'];
  notExecutedPart: BnHOrderNotExecutedPartV2;
  rejectDate?: Maybe<Scalars['ZonedDateTime']>;
  rejectReason?: Maybe<BnHOrderRejectReasonV2>;
  side: BnHSideV2;
  status: BnHOrderStatusV2;
};

export type BnHPositionsSummary = {
  __typename?: 'BnHPositionsSummary';
  /** нереализованная прибыль/убыток по всем открытым позициям */
  grossUnrealizedPnlSum: MoneyV2;
  /**
   * сколько денег списали с основного счета биллинга для открытых позиций
   * (а именно имеющегося на данный момент количества инструментов в открытой позиции) за вычетом комиссий
   */
  investmentSum: MoneyV2;
};

export type BnHPromoChart = {
  __typename?: 'BnHPromoChart';
  data: Array<BnHPromoChartItem>;
};

export type BnHPromoChartItem = {
  __typename?: 'BnHPromoChartItem';
  /** depends on Accept-Language http header */
  title?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type BnHSellOrderFeeV2 = {
  __typename?: 'BnHSellOrderFeeV2';
  leaveFee: MoneyV2;
  leaveFeePercent: Scalars['Percent'];
  successFee: MoneyV2;
  successFeePercent: Scalars['Percent'];
};

export enum BnHSideV2 {
  Buy = 'Buy',
  Sell = 'Sell',
}

export type BnHUserCardV2 = {
  __typename?: 'BnHUserCardV2';
  /** Актуальный InvestAmount для отображения пользователю */
  actualInvestedAmount: MoneyV2;
  /** Актуальный Pnl для отображения пользователю */
  actualPnl: MoneyV2;
  /** Актуальный PnlPercent для отображения пользователю */
  actualPnlPercent: Scalars['Percent'];
  /** дата и время архивации карточки. Для сортировки в архиве */
  archivedDate?: Maybe<Scalars['ZonedDateTime']>;
  /** дата и время создания карточки. Для правильной сортировки */
  creationDate: Scalars['ZonedDateTime'];
  /** текущая стоимость позиции */
  currentPositionValue: MoneyV2;
  /** сумма исполненных ордеров(buy) + ордеров в ожидании с учетом комиссии; */
  debitedFromAccount: MoneyV2;
  grossUnrealizedPnl: MoneyV2;
  grossUnrealizedPnlPercent: Scalars['Percent'];
  /** флаг наличия ордеров в статусе FILLED */
  hasFilledOrders: Scalars['Boolean'];
  id: Scalars['ID'];
  /** новая сущность на бекенде */
  idea: BnHIdeaV2;
  /**
   * Допустим было 3 покупки
   * 1 акция по 100$
   * 2 акции по 150$
   * 1 акция по 200$
   * Тогда initialPositionValue будет:
   * 1×100 + 2×150 + 1×200 = 600$.
   * Не меняется и имеет семантику: за сколько купили первоначальное количество.
   */
  initialPositionValue: MoneyV2;
  isArchived: Scalars['Boolean'];
  /** дата и время последних изменений в карточке. Для правильной сортировки */
  lastActivityDate: Scalars['ZonedDateTime'];
  netRealizedPnl: MoneyV2;
  netRealizedPnlPercent: Scalars['Percent'];
  orders: Array<BnHOrderV2>;
  positionQty: Scalars['Float'];
  /**
   * Актуальное количество инструмента в позиции по ценам покупки.
   * Допустип: первоначально позиция была открыта с 3 акциями по 10 USD каждая.
   * Потом продали 1 акцию. Значит это поле будет отражать: 2 * 10 USD.
   */
  positionValueByInitialPrices: MoneyV2;
  /** информация о комиссиях перед выводом(зависит от кол-ва акций которые выбирает юзер) */
  preparedSellInfo?: Maybe<BnhPreparedLeaveInfoV2>;
  /** сумма всех исполененных продаж(sell) с учетом комиссий */
  transferredToAccount: MoneyV2;
};

export type BnHUserCardV2OrdersArgs = {
  filter?: Maybe<BnhOrdersFilterV2>;
};

export type BnHUserCardV2PreparedSellInfoArgs = {
  request: BnhPreparedSellInfoRequestV2;
};

export type BnhIdeaFeeV2 = {
  __typename?: 'BnhIdeaFeeV2';
  enterFeePercent: Scalars['Percent'];
  leaveFeePercent: Scalars['Percent'];
  successFeePercent: Scalars['Percent'];
};

export type BnhOrdersFilterV2 = {
  sides: Array<BnHSideV2>;
  statuses: Array<BnHOrderStatusV2>;
};

export type BnhPreparedLeaveInfoV2 = {
  __typename?: 'BnhPreparedLeaveInfoV2';
  leaveFee: MoneyV2;
  leaveFeePercent: Scalars['Percent'];
  netUnrealizedPnl: MoneyV2;
  successFee: MoneyV2;
  successFeePercent: Scalars['Percent'];
  toBeTransferredToAccount: MoneyV2;
};

export type BnhPreparedSellInfoRequestV2 = {
  qty: Scalars['Float'];
};

export type CardDetail = {
  __typename?: 'CardDetail';
  cardExpirationDate?: Maybe<Scalars['String']>;
  cardHolderName: Scalars['String'];
  cardNumber: Scalars['String'];
};

export type Clearing = {
  __typename?: 'Clearing';
  /**
   * query - bank name or swift
   * returns at most 10 matched banks
   */
  abroadBankInfoList?: Maybe<Array<ClearingAbroadBankInfo>>;
  currentUser?: Maybe<CurrentUser>;
  depositInstruments?: Maybe<Array<ClearingDepositInstrument>>;
  exchange?: Maybe<MoneyV2>;
  exchangeRate?: Maybe<Scalars['Float']>;
  /** Will return owned for sender withdraw requests */
  findOwnWithdrawRequests?: Maybe<WithdrawRequestPage>;
  /**
   * query - bank name or bik
   * returns at most 10 matched banks
   */
  russianBankInfoList?: Maybe<Array<ClearingRussianBankInfo>>;
  /**
   * При наличии нескольких карточных инструментов, относящихся к одному типу-продукту-валюте (к примеру, CARD-UTCOM-RUB),
   * отдаёт только один (дефолтный)
   */
  withdrawInstruments?: Maybe<Array<ClearingWithdrawInstrument>>;
  /**
   * При наличии нескольких карточных инструментов, относящихся к одному типу-продукту-валюте (к примеру, CARD-UTCOM-RUB),
   * отдаёт все
   */
  withdrawInstrumentsV2?: Maybe<Array<ClearingWithdrawInstrument>>;
};

export type ClearingAbroadBankInfoListArgs = {
  query: Scalars['String'];
};

export type ClearingDepositInstrumentsArgs = {
  product: Scalars['String'];
};

export type ClearingExchangeArgs = {
  exchange: ClearingExchangeRequest;
};

export type ClearingExchangeRateArgs = {
  exchangeRate: ClearingExchangeRateRequest;
};

export type ClearingFindOwnWithdrawRequestsArgs = {
  filter: OwnWithdrawRequestFilterInput;
  page: WithdrawRequestPageInput;
};

export type ClearingRussianBankInfoListArgs = {
  query: Scalars['String'];
};

export type ClearingWithdrawInstrumentsArgs = {
  product: Scalars['String'];
};

export type ClearingWithdrawInstrumentsV2Args = {
  product: Scalars['String'];
};

export type ClearingAbroadBankDepositDetails = {
  __typename?: 'ClearingAbroadBankDepositDetails';
  accountOfReceiver?: Maybe<Scalars['String']>;
  bankAddress: Scalars['String'];
  bankName: Scalars['String'];
  correspondentAccount?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  intermediaryBankName?: Maybe<Scalars['String']>;
  intermediarySwift?: Maybe<Scalars['String']>;
  purposeOfPayment: Scalars['String'];
  recipient: Scalars['String'];
  recipientAddress: Scalars['String'];
  swift: Scalars['String'];
};

export type ClearingAbroadBankInfo = {
  __typename?: 'ClearingAbroadBankInfo';
  address: Scalars['String'];
  name: Scalars['String'];
  swift: Scalars['String'];
};

export type ClearingBankCardPaymentSystem = {
  __typename?: 'ClearingBankCardPaymentSystem';
  fee: Scalars['Float'];
  id: Scalars['Long'];
  name: Scalars['String'];
};

export type ClearingConversion = {
  __typename?: 'ClearingConversion';
  from: Scalars['CurrencyScalar'];
  id: Scalars['ID'];
  to: Scalars['CurrencyScalar'];
};

export type ClearingCorrection = {
  __typename?: 'ClearingCorrection';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ClearingDepositDetails =
  | ClearingAbroadBankDepositDetails
  | ClearingBankCardPaymentSystem
  | ClearingProviderWalletTransferPaymentSystem
  | ClearingRussianBankDepositDetails;

export type ClearingDepositInstrument = {
  __typename?: 'ClearingDepositInstrument';
  currency: Scalars['CurrencyScalar'];
  /**
   * when:
   * - BANK_CARD -> ClearingBankCardPaymentSystem
   * - PROVIDER_WALLET_TRANSFER -> ClearingProviderWalletTransferPaymentSystem
   * - OFFLINE_BANK_TRANSFER -> null
   * - ONLINE_BANK_TRANSFER -> ClearingRussianBankDepositDetails | ClearingAbroadBankDepositDetails
   * - BLOCKCHAIN -> null
   * - MAIN_ACCOUNT -> null
   * - UTEX_ACCOUNT -> null
   * - MANUAL -> null
   */
  details?: Maybe<ClearingDepositDetails>;
  maximum?: Maybe<Scalars['Float']>;
  minimum?: Maybe<Scalars['Float']>;
  type: ClearingDepositInstrumentType;
};

export enum ClearingDepositInstrumentType {
  BankCard = 'BANK_CARD',
  Blockchain = 'BLOCKCHAIN',
  MainAccount = 'MAIN_ACCOUNT',
  Manual = 'MANUAL',
  OfflineBankTransfer = 'OFFLINE_BANK_TRANSFER',
  OnlineBankTransfer = 'ONLINE_BANK_TRANSFER',
  ProviderWalletTransfer = 'PROVIDER_WALLET_TRANSFER',
  UtexAccount = 'UTEX_ACCOUNT',
}

export type ClearingExchangeRateRequest = {
  from: Scalars['CurrencyScalar'];
  to: Scalars['CurrencyScalar'];
};

export type ClearingExchangeRequest = {
  from: MoneyInputV2;
  to: Scalars['CurrencyScalar'];
};

export type ClearingProviderWalletTransferPaymentSystem = {
  __typename?: 'ClearingProviderWalletTransferPaymentSystem';
  fee: Scalars['Float'];
  id: Scalars['Long'];
  name: Scalars['String'];
};

export type ClearingRussianBankDepositDetails = {
  __typename?: 'ClearingRussianBankDepositDetails';
  accountOfReceiver: Scalars['String'];
  bankAddress: Scalars['String'];
  bankName: Scalars['String'];
  bic: Scalars['String'];
  correspondentAccount: Scalars['String'];
  correspondentBankAccount: Scalars['String'];
  intermediaryBankName: Scalars['String'];
  purposeOfPayment: Scalars['String'];
  recipient: Scalars['String'];
  recipientAddress: Scalars['String'];
};

export type ClearingRussianBankInfo = {
  __typename?: 'ClearingRussianBankInfo';
  address: Scalars['String'];
  bic: Scalars['String'];
  name: Scalars['String'];
};

export type ClearingWithdrawFee = ClearingWithdrawFixedFee | ClearingWithdrawPercentFee;

export type ClearingWithdrawFixedFee = {
  __typename?: 'ClearingWithdrawFixedFee';
  amount: MoneyV2;
};

export type ClearingWithdrawInstrument = {
  __typename?: 'ClearingWithdrawInstrument';
  currency: Scalars['CurrencyScalar'];
  fee: ClearingWithdrawFee;
  /** will be not null for CARD type */
  id?: Maybe<Scalars['ID']>;
  maximum: Scalars['Float'];
  minimum: Scalars['Float'];
  /** will be not null for CARD type */
  name?: Maybe<Scalars['String']>;
  type: ClearingWithdrawInstrumentType;
};

export enum ClearingWithdrawInstrumentType {
  AlfaBankAccount = 'ALFA_BANK_ACCOUNT',
  BankTransfer = 'BANK_TRANSFER',
  Card = 'CARD',
  Crypto = 'CRYPTO',
  ProviderWallet = 'PROVIDER_WALLET',
}

export type ClearingWithdrawPercentFee = {
  __typename?: 'ClearingWithdrawPercentFee';
  percent?: Maybe<Scalars['Percent']>;
};

export type ClearingWithdrawRequest = {
  __typename?: 'ClearingWithdrawRequest';
  amount: Scalars['Float'];
  comment?: Maybe<Scalars['String']>;
  commissionAmount: Scalars['Float'];
  commissionCurrency: Scalars['CurrencyScalar'];
  createdAt: Scalars['ZonedDateTime'];
  currency: Scalars['CurrencyScalar'];
  id: Scalars['Long'];
  payoutId?: Maybe<Scalars['String']>;
  requestId: Scalars['ID'];
  status: WithdrawRequestStatus;
  type: DetailType;
  updatedAt: Scalars['ZonedDateTime'];
  withdrawDetail: WithdrawDetail;
};

export type ClearingWithdrawSoftBlock = {
  __typename?: 'ClearingWithdrawSoftBlock';
  auditInfo: LunaReadOnlyAuditInfo;
  expirationDate?: Maybe<Scalars['ZonedDateTime']>;
  reason?: Maybe<Scalars['String']>;
  user: User;
};

export type Compliance = {
  __typename?: 'Compliance';
  agreement?: Maybe<ComplianceAgreement>;
};

export type ComplianceAgreement = {
  __typename?: 'ComplianceAgreement';
  content: Scalars['String'];
  updatedAt: Scalars['ZonedDateTime'];
  version: Scalars['String'];
};

export type CryptoDeposit = {
  __typename?: 'CryptoDeposit';
  amount: Scalars['Float'];
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['ZonedDateTime'];
  createdBy?: Maybe<User>;
  currency: Scalars['CurrencyScalar'];
  depositId: Scalars['String'];
  id: Scalars['Long'];
  /** UUIDv4 */
  incomingTransactionId: Scalars['String'];
  product?: Maybe<Scalars['String']>;
  providerId: Scalars['String'];
  status?: Maybe<CryptoDepositStatus>;
  updatedAt: Scalars['ZonedDateTime'];
  updatedBy?: Maybe<User>;
  user: User;
};

export enum CryptoDepositStatus {
  /** Crypto transaction event received. */
  Created = 'CREATED',
  /** Fail to process billing deposit operation. */
  Failed = 'FAILED',
  /** Crypto deposit event has inconsistent state. Deposit will not be processed in billing. */
  Ignored = 'IGNORED',
  /** Crypto deposit event received. Deposit is not yet processed in billing. */
  Pending = 'PENDING',
  /** Crypto deposit successfully processed in billing. */
  Processed = 'PROCESSED',
}

export type CryptoDetail = {
  __typename?: 'CryptoDetail';
  destinationAddress: Scalars['String'];
  destinationTag?: Maybe<Scalars['String']>;
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String'];
  description: Scalars['String'];
  fractionDigits: Scalars['Int'];
  rateToUsd?: Maybe<Scalars['Float']>;
  site: Scalars['String'];
};

export type CurrencyRateToUsdArgs = {
  dateTime?: Maybe<Scalars['ZonedDateTime']>;
};

/** The type assumes expansion with other services, for example in billing - CurrentUser.balance */
export type CurrentUser = {
  __typename?: 'CurrentUser';
  /** will return balances just with MAIN_ACCOUNT type */
  balances?: Maybe<Array<BillingAccount>>;
  clearingWithdrawSoftBlock?: Maybe<ClearingWithdrawSoftBlock>;
  id: Scalars['String'];
  otpType?: Maybe<UserOtpType>;
  userInfo?: Maybe<UserInfo>;
  utexBalance?: Maybe<UtexBalance>;
};

/** The type assumes expansion with other services, for example in billing - CurrentUser.balance */
export type CurrentUserUtexBalanceArgs = {
  currency?: Maybe<Scalars['CurrencyScalar']>;
};

export enum DatePrecision {
  Approximate = 'APPROXIMATE',
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Year = 'YEAR',
}

export type DateTimeRangeV2 = {
  from?: Maybe<Scalars['ZonedDateTime']>;
  to?: Maybe<Scalars['ZonedDateTime']>;
};

export enum DetailType {
  Abroad = 'ABROAD',
  AlfaBankAccount = 'ALFA_BANK_ACCOUNT',
  Card = 'CARD',
  Crypto = 'CRYPTO',
  ProviderWallet = 'PROVIDER_WALLET',
  Russian = 'RUSSIAN',
}

export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Feed = {
  __typename?: 'Feed';
  post?: Maybe<FeedPost>;
  posts: FeedPostPage;
};

export type FeedPostArgs = {
  id: Scalars['ID'];
};

export type FeedPostsArgs = {
  pagination?: Maybe<FeedPagination>;
};

export type FeedPagination = {
  /** if null - default 0 */
  pageNumber?: Maybe<Scalars['Long']>;
  /** if null - default 20 */
  pageSize?: Maybe<Scalars['Long']>;
};

export type FeedPost = {
  __typename?: 'FeedPost';
  backgroundColor: Scalars['String'];
  date?: Maybe<Scalars['ZonedDateTime']>;
  foregroundColor: Scalars['String'];
  hasText: Scalars['Boolean'];
  id: Scalars['ID'];
  image: FeedPoster;
  /** in markdown format */
  leadParagraph: Scalars['String'];
  link?: Maybe<Scalars['String']>;
  linkText?: Maybe<Scalars['String']>;
  /** in markdown format (can be null if hasText == false) */
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  /** Current values: [POST|INVEST_IDEA] */
  type: Scalars['String'];
};

export type FeedPostPage = PagedResponseV2 & {
  __typename?: 'FeedPostPage';
  content: Array<FeedPost>;
  pageInfo: PageInfoV2;
};

export type FeedPoster = {
  __typename?: 'FeedPoster';
  height: Scalars['Long'];
  url: Scalars['String'];
  width: Scalars['Long'];
};

export type Ideas = {
  __typename?: 'Ideas';
  activePage: IdeasActivePage;
  calendar: IdeasCalendar;
  /** Список IPO (limited) идей с закупкой в статусе CLOSED */
  closedIpoStats: IdeasClosedIpoStatsPage;
  /** Список IPO (limited) идей с закупкой в статусе OPENED */
  openedIpoStats: IdeasOpenedIpoStatsPage;
};

export type IdeasActivePageArgs = {
  pagination?: Maybe<PaginationArgs>;
};

export type IdeasCalendarArgs = {
  pagination?: Maybe<PaginationArgs>;
};

export type IdeasClosedIpoStatsArgs = {
  pagination?: Maybe<PaginationArgs>;
};

export type IdeasOpenedIpoStatsArgs = {
  pagination?: Maybe<PaginationArgs>;
};

export type IdeasActiveEntry = {
  __typename?: 'IdeasActiveEntry';
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  investmentUrl: Scalars['String'];
  ipoStartDate?: Maybe<Scalars['ZonedDateTime']>;
  logoUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

export type IdeasActivePage = {
  __typename?: 'IdeasActivePage';
  list: Array<IdeasActiveEntry>;
  page: Page;
};

export type IdeasCalendar = {
  __typename?: 'IdeasCalendar';
  list: Array<IdeasCalendarEntry>;
  page: Page;
};

export type IdeasCalendarEntry = {
  __typename?: 'IdeasCalendarEntry';
  description: Scalars['String'];
  id: Scalars['Int'];
  investmentUrl?: Maybe<Scalars['String']>;
  limitedIdeaId?: Maybe<Scalars['Int']>;
  logoUrl?: Maybe<Scalars['String']>;
  precision: DatePrecision;
  startDate: Scalars['ZonedDateTime'];
  ticker: Scalars['String'];
  title: Scalars['String'];
};

export type IdeasClosedIpoStats = {
  __typename?: 'IdeasClosedIpoStats';
  /** цена закрытия IPO */
  closePrice: MoneyV2;
  /** дата выхода из инвестиции */
  ipoFinishDate: Scalars['ZonedDateTime'];
  /** дата выхода компании на IPO */
  ipoStartDate: Scalars['ZonedDateTime'];
  /** URL логотипа компании */
  logoUrl: Scalars['String'];
  /** прибыль/убыток с учётом комиссий */
  netPnL: Scalars['Percent'];
  /** стартовая цена IPO */
  openPrice: MoneyV2;
  /** Название компании (локализованное) */
  title: Scalars['String'];
};

export type IdeasClosedIpoStatsPage = {
  __typename?: 'IdeasClosedIpoStatsPage';
  list: Array<IdeasClosedIpoStats>;
  page: Page;
};

export type IdeasOpenedIpoStats = {
  __typename?: 'IdeasOpenedIpoStats';
  /** текущая цена акции компании на бирже */
  currentPrice: MoneyV2;
  /** текущая прибыль/убыток без учёта комиссий */
  grossPnL: Scalars['Percent'];
  /** дата выхода из инвестиции */
  ipoFinishDate: Scalars['ZonedDateTime'];
  /** дата выхода компании на IPO */
  ipoStartDate: Scalars['ZonedDateTime'];
  /** URL логотипа компании */
  logoUrl: Scalars['String'];
  /** стартовая цена IPO */
  openPrice: MoneyV2;
  /** Название компании (локализованное) */
  title: Scalars['String'];
};

export type IdeasOpenedIpoStatsPage = {
  __typename?: 'IdeasOpenedIpoStatsPage';
  list: Array<IdeasOpenedIpoStats>;
  page: Page;
};

export type InvestmentRegistry = {
  __typename?: 'InvestmentRegistry';
  findInvestmentIdea?: Maybe<InvestmentRegistryIdea>;
};

export type InvestmentRegistryFindInvestmentIdeaArgs = {
  id: Scalars['ID'];
};

export type InvestmentRegistryIdea = {
  __typename?: 'InvestmentRegistryIdea';
  details: InvestmentRegistryIdeaDetails;
  id: Scalars['ID'];
};

export type InvestmentRegistryIdeaDetails = BnHIdeaV2 | LimitedIdeaV2 | StockV2 | UnlimitedIdeaV2;

export type Limited = {
  __typename?: 'Limited';
  idea?: Maybe<LimitedIdeaV2>;
  /** список доступных идей зависит от прав пользователя */
  ideas: Array<LimitedIdeaV2>;
  positionsSummary?: Maybe<LimitedPositionsSummary>;
  userCard?: Maybe<LimitedUserCardV2>;
  userCards?: Maybe<Array<LimitedUserCardV2>>;
};

export type LimitedIdeaArgs = {
  id: Scalars['ID'];
};

export type LimitedIdeasArgs = {
  filter?: LimitedIdeasFilter;
};

export type LimitedUserCardArgs = {
  id: Scalars['ID'];
};

export type LimitedUserCardsArgs = {
  request?: LimitedUserCardsRequestV2;
};

export type LimitedBuyOrderFeeV2 = {
  __typename?: 'LimitedBuyOrderFeeV2';
  enterFee: MoneyV2;
  enterFeePercent: Scalars['Percent'];
};

export type LimitedChartPointV2 = {
  __typename?: 'LimitedChartPointV2';
  close: Scalars['Float'];
  date: Scalars['ZonedDateTime'];
  high: Scalars['Float'];
  low: Scalars['Float'];
  open: Scalars['Float'];
  volume: Scalars['Float'];
};

export type LimitedChartRequestV2 = {
  from: Scalars['ZonedDateTime'];
  to: Scalars['ZonedDateTime'];
};

export type LimitedChartV2 = {
  __typename?: 'LimitedChartV2';
  points: Array<LimitedChartPointV2>;
};

export enum LimitedIdeaBuyForbiddenReason {
  /** Дата окончания принятия заявок уже прошла */
  NoLongerAccepted = 'NO_LONGER_ACCEPTED',
  /** Превышен литим активных buy-ордеров */
  OrderCountThresholdExceeded = 'ORDER_COUNT_THRESHOLD_EXCEEDED',
  /** Уже идет закупка */
  ProcurementExists = 'PROCUREMENT_EXISTS',
}

export type LimitedIdeaFeeV2 = {
  __typename?: 'LimitedIdeaFeeV2';
  earlyLeaveFeePercent: Scalars['Percent'];
  enterFeePercent: Scalars['Percent'];
  leaveFeePercent: Scalars['Percent'];
  successFeePercent: Scalars['Percent'];
};

export type LimitedIdeaRasterUrl = {
  __typename?: 'LimitedIdeaRasterUrl';
  /** Множитель, показывающий во сколько раз картинка больше, чем нормальный размер (x1, x2, x3, x4 и т.д.) */
  factor: Scalars['Float'];
  url: Scalars['String'];
};

export enum LimitedIdeaRiskLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export type LimitedIdeaV2 = {
  __typename?: 'LimitedIdeaV2';
  /** Причина недоступности входа (покупки) в данную идею. Null, если войти можно */
  buyForbiddenReason?: Maybe<LimitedIdeaBuyForbiddenReason>;
  /**
   * Дата, до которой можно отзывать оставленныe buy ордера
   * В текущей реализации равно finishRequestDate
   */
  cancelBuyOrderRequestDate?: Maybe<Scalars['ZonedDateTime']>;
  category: Scalars['String'];
  chart: LimitedChartV2;
  /** depends on Accept-Language http header */
  chartDescriptionLocalized: Scalars['String'];
  /** depends on Accept-Language http header */
  descriptionLocalized: Scalars['String'];
  fees?: Maybe<LimitedIdeaFeeV2>;
  /** Дата окончания принятия заявок в идею */
  finishRequestDate?: Maybe<Scalars['ZonedDateTime']>;
  /** depends on Accept-Language http header */
  fullDescriptionInMarkdownLocalized?: Maybe<Scalars['String']>;
  /** depends on Accept-Language http header */
  fullDescriptionLocalized: Scalars['String'];
  id: Scalars['ID'];
  /** Дата проведения IPO, может быть не определена тк точно дату анонсируют под самое IPO */
  ipoDate?: Maybe<Scalars['ZonedDateTime']>;
  isArchived: Scalars['Boolean'];
  /** Порядок идеи в публичном списке всех идей (глобально уникален в рамках limited, unlimited, bnh). Чем больше число - тем выше должна быть идея в списке. */
  listIndex: Scalars['Long'];
  lockupFinishDate?: Maybe<Scalars['ZonedDateTime']>;
  /** URL-ы логотипов в растровом формате (могут отсутствовать) */
  logoRasterUrl?: Maybe<Array<LimitedIdeaRasterUrl>>;
  /** URL логотипа в SVG-формате */
  logoUrl: Scalars['String'];
  marketData: LimitedMarketDataV2;
  minAmount: MoneyV2;
  name: Scalars['String'];
  /** Срок инвестирования в днях */
  period: Scalars['Long'];
  /** прогнозируемый доход */
  profit: Scalars['Percent'];
  promoChart?: Maybe<LimitedPromoChart>;
  riskLevel: LimitedIdeaRiskLevel;
  ticker?: Maybe<Scalars['String']>;
};

export type LimitedIdeaV2ChartArgs = {
  request: LimitedChartRequestV2;
};

export type LimitedIdeaV2FeesArgs = {
  amount: MoneyInputV2;
};

export type LimitedIdeasFilter = {
  categories?: Array<Scalars['String']>;
};

export type LimitedMarketDataV2 = {
  __typename?: 'LimitedMarketDataV2';
  /** цена по которой юзер может продать, bid = ask */
  ask?: Maybe<MoneyV2>;
  bid?: Maybe<MoneyV2>;
};

export type LimitedOrderExecutedPartV2 = {
  __typename?: 'LimitedOrderExecutedPartV2';
  accountMovement: MoneyV2;
  fees: LimitedOrderFeeV2;
  price: MoneyV2;
  qty: Scalars['Float'];
};

export type LimitedOrderFeeV2 = LimitedBuyOrderFeeV2 | LimitedSellOrderFeeV2;

export type LimitedOrderNotExecutedPartV2 = {
  __typename?: 'LimitedOrderNotExecutedPartV2';
  accountMovement: MoneyV2;
  /**
   * Buy - 0, если ордер исполнен, иначе предполагаемая комиссия от всей суммы ордера (requestedAmount)
   * Sell - 0, если ордер исполнен, иначе предполагаемая комиссия на выход
   */
  fees: LimitedOrderFeeV2;
  qty: Scalars['Float'];
};

export type LimitedOrderRejectReasonV2 = {
  __typename?: 'LimitedOrderRejectReasonV2';
  /** ключ локализации или свободное сообщение */
  code: Scalars['String'];
  /** параметры для локализации формализованного сообщения */
  params?: Maybe<Array<Maybe<MapItem>>>;
};

export enum LimitedOrderSideV2 {
  Buy = 'Buy',
  Sell = 'Sell',
}

export enum LimitedOrderStatusV2 {
  Cancelled = 'CANCELLED',
  Filled = 'FILLED',
  Locked = 'LOCKED',
  Opened = 'OPENED',
  Rejected = 'REJECTED',
  RejectedAndAcknowledged = 'REJECTED_AND_ACKNOWLEDGED',
}

export type LimitedOrderV2 = {
  __typename?: 'LimitedOrderV2';
  /**
   * заполнено только у buy ордеров в статусе FILLED, но не у всех:
   * есть старые закупки, где allocation = null, и для ордеров исполненных в 0 это поле тоже будет null
   */
  allocation?: Maybe<Scalars['Percent']>;
  canceledDate?: Maybe<Scalars['ZonedDateTime']>;
  card: LimitedUserCardV2;
  createdDate: Scalars['ZonedDateTime'];
  /** только для селл ордеров, для бай == null */
  earlyLeave?: Maybe<Scalars['Boolean']>;
  executedPart: LimitedOrderExecutedPartV2;
  id: Scalars['ID'];
  idea: LimitedIdeaV2;
  /** Если по ордеру не было ни одного сведения - равна createdDate */
  lastExecutionDate: Scalars['ZonedDateTime'];
  notExecutedPart: LimitedOrderNotExecutedPartV2;
  rejectDate?: Maybe<Scalars['ZonedDateTime']>;
  rejectReason?: Maybe<LimitedOrderRejectReasonV2>;
  side: LimitedOrderSideV2;
  status: LimitedOrderStatusV2;
  /** заполнено только у buy ордеров в статусе FILLED, у которых была 0я аллокация */
  zeroAllocationInfo?: Maybe<LimitedZeroAllocationInfo>;
};

export type LimitedOrdersFilterV2 = {
  /** if empty list == fetch all sides */
  sides?: Maybe<Array<LimitedOrderSideV2>>;
  /** if empty list == fetch all statuses */
  statuses?: Maybe<Array<LimitedOrderStatusV2>>;
};

export type LimitedPositionsSummary = {
  __typename?: 'LimitedPositionsSummary';
  /** нереализованная прибыль/убыток по всем открытым позициям */
  grossUnrealizedPnlSum: MoneyV2;
  /** сколько денег списали с основного счета биллинга для открытых позиций за вычетом комиссий */
  investmentSum: MoneyV2;
};

export type LimitedPreparedEarlyLeaveInfoV2 = {
  __typename?: 'LimitedPreparedEarlyLeaveInfoV2';
  earlyLeaveFee: MoneyV2;
  earlyLeaveFeePercent: Scalars['Percent'];
  leaveFee: MoneyV2;
  leaveFeePercent: Scalars['Percent'];
  netUnrealizedPnl: MoneyV2;
  successFee: MoneyV2;
  successFeePercent: Scalars['Percent'];
  toBeTransferredToAccount: MoneyV2;
};

export type LimitedPreparedLeaveInfoV2 = {
  __typename?: 'LimitedPreparedLeaveInfoV2';
  leaveFee: MoneyV2;
  leaveFeePercent: Scalars['Percent'];
  netUnrealizedPnl: MoneyV2;
  successFee: MoneyV2;
  successFeePercent: Scalars['Percent'];
  toBeTransferredToAccount: MoneyV2;
};

export type LimitedPromoChart = {
  __typename?: 'LimitedPromoChart';
  data: Array<LimitedPromoChartItem>;
};

export type LimitedPromoChartItem = {
  __typename?: 'LimitedPromoChartItem';
  /** depends on Accept-Language http header */
  title?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type LimitedSellOrderFeeV2 = {
  __typename?: 'LimitedSellOrderFeeV2';
  earlyLeaveFee: MoneyV2;
  earlyLeaveFeePercent: Scalars['Percent'];
  leaveFee: MoneyV2;
  leaveFeePercent: Scalars['Percent'];
  successFee: MoneyV2;
  successFeePercent: Scalars['Percent'];
};

export type LimitedUserCardV2 = {
  __typename?: 'LimitedUserCardV2';
  /**
   * Актуальный InvestAmount для отображения пользователю
   * Есть 3 варианта
   * 1 - в карточке есть открытый ордер - сумма ордеров
   * 2 - в карточке qty > 0 (открытая позиция) - qty * executionPrice (количество купленных акций * цена акции на момент покупки)
   * 3 - в карточке qty == 0 и hasFilledOrders == true (позиция закрыта)  - transferredFromAccount
   */
  actualInvestedAmount: MoneyV2;
  /**
   * Актуальный Pnl для отображения пользователю
   * Есть 3 варианта
   * 1 - в карточке есть открытый ордер - 0
   * 2 - в карточке qty > 0 (открытая позиция) - grosssUnrealizedPnl
   * 3 - в карточке qty == 0 и hasFilledOrders == true (позиция закрыта) - netRealizedPnl
   */
  actualPnl: MoneyV2;
  /** Актуальный PnlPercent для отображения пользователю */
  actualPnlPercent: Scalars['Percent'];
  /** дата и время архивации карточки. Для сортировки в архиве */
  archivedDate?: Maybe<Scalars['ZonedDateTime']>;
  /** дата и время создания карточки. Для правильной сортировки */
  creationDate: Scalars['ZonedDateTime'];
  /** текущая стоимость позиции */
  currentPositionValue: MoneyV2;
  /** сумма исполненных ордеров(buy) + ордеров в ожидании с учетом комиссии; */
  debitedFromAccount: MoneyV2;
  /** признак того, что из идеи доступен ранний выход в рамках карточки */
  earlyLeaveEnabled: Scalars['Boolean'];
  /**
   * Тк в limited идеях нет множественного входа и частичных выходов, то формула рассчета выглядит так:
   * количествоАкций * ценаПокупи - количествоАкций * текущаяЦена
   */
  grossUnrealizedPnl: MoneyV2;
  grossUnrealizedPnlPercent: Scalars['Percent'];
  /** флаг наличия ордеров в статусе FILLED */
  hasFilledOrders: Scalars['Boolean'];
  /** новая сущность на бекенде */
  id: Scalars['ID'];
  idea: LimitedIdeaV2;
  /** стоимость позиции по ценам покупок */
  initialPositionValue: MoneyV2;
  isArchived: Scalars['Boolean'];
  /** дата и время последних изменений в карточке. Для правильной сортировки */
  lastActivityDate: Scalars['ZonedDateTime'];
  lockupFinishDate?: Maybe<Scalars['ZonedDateTime']>;
  /**
   * Тк в limited идеях нет множественного входа и частичных выходов, то формула рассчета выглядит так:
   * (количествоАкций * ценаПокупи - комиссии на вход) - (количествоАкций * цена продажи - всеКомиссииНаВыход)
   * Должно выполняться условие
   * debitedFromAccount + netRealizedPnl = transferredToAccount
   */
  netRealizedPnl: MoneyV2;
  netRealizedPnlPercent: Scalars['Percent'];
  orders: Array<LimitedOrderV2>;
  positionQty: Scalars['Float'];
  /** информация о комиссиях перед ранним выводом */
  preparedEarlyLeaveInfo?: Maybe<LimitedPreparedEarlyLeaveInfoV2>;
  /** информация о комиссиях */
  preparedLeaveInfo: LimitedPreparedLeaveInfoV2;
  /** сумма всех исполененных продаж(sell) с учетом комиссий */
  transferredToAccount: MoneyV2;
};

export type LimitedUserCardV2OrdersArgs = {
  filter?: Maybe<LimitedOrdersFilterV2>;
};

export type LimitedUserCardsRequestV2 = {
  /** В случае если isArchived == true, возвращаются те карточки с флагом isArchived == true,  у которых флаг hasFilledOrders == true */
  isArchived?: Scalars['Boolean'];
};

export type LimitedZeroAllocationInfo = {
  __typename?: 'LimitedZeroAllocationInfo';
  /** При allocation = null и для ордеров исполненных в 0 - не заполнены */
  expectedEnterFee?: Maybe<MoneyV2>;
  expectedEnterFeePercent?: Maybe<Scalars['Percent']>;
  expectedSumForTrade?: Maybe<MoneyV2>;
  /** Сумма заявки на покупку от пользователя */
  orderAmount: MoneyV2;
  priceOfStock: MoneyV2;
};

export type LunaReadOnlyAuditInfo = {
  __typename?: 'LunaReadOnlyAuditInfo';
  createdAt?: Maybe<Scalars['ZonedDateTime']>;
  createdBy?: Maybe<User>;
};

export type MapItem = {
  __typename?: 'MapItem';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Money = {
  __typename?: 'Money';
  currency: Scalars['String'];
  exp?: Maybe<Scalars['Int']>;
  value: Scalars['Float'];
};

export type MoneyInputV2 = {
  currency: Scalars['CurrencyScalar'];
  value: Scalars['String'];
};

export type MoneyV2 = {
  __typename?: 'MoneyV2';
  currency: Currency;
  value: Scalars['String'];
};

export type OwnWithdrawRequestFilterInput = {
  createdAtFrom?: Maybe<Scalars['ZonedDateTime']>;
  createdAtTo?: Maybe<Scalars['ZonedDateTime']>;
  currencies?: Maybe<Array<Scalars['CurrencyScalar']>>;
  products?: Maybe<Array<Scalars['String']>>;
  statuses?: Maybe<Array<WithdrawRequestStatus>>;
  types?: Maybe<Array<DetailType>>;
  updatedAtFrom?: Maybe<Scalars['ZonedDateTime']>;
  updatedAtTo?: Maybe<Scalars['ZonedDateTime']>;
};

export type Page = {
  __typename?: 'Page';
  hasContent?: Maybe<Scalars['Boolean']>;
  hasMore: Scalars['Boolean'];
  number: Scalars['Int'];
  numberOfElements?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  totalElements?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PageInfoV2 = {
  __typename?: 'PageInfoV2';
  number: Scalars['Long'];
  size: Scalars['Long'];
  totalElements: Scalars['Long'];
  totalPages: Scalars['Long'];
};

export type PageRequestV2 = {
  /** if null - default 0 */
  pageNumber?: Maybe<Scalars['Long']>;
  /** if null - default 100 */
  pageSize?: Maybe<Scalars['Long']>;
  /** if null or empty - default sort applied */
  sort?: Maybe<Array<SortFieldV2>>;
};

export type PageRequestWithoutSortV2 = {
  /** if null - default 0 */
  pageNumber?: Maybe<Scalars['Long']>;
  /** if null - default 100 */
  pageSize?: Maybe<Scalars['Long']>;
};

export type PagedResponseV2 = {
  pageInfo: PageInfoV2;
};

export type PaginationArgs = {
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  sort?: Maybe<Sort>;
};

export type ProviderWalletDetail = {
  __typename?: 'ProviderWalletDetail';
  provider: Scalars['String'];
  walletId: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  billing?: Maybe<Billing>;
  bnh?: Maybe<BnH>;
  clearing?: Maybe<Clearing>;
  compliance?: Maybe<Compliance>;
  currentUser?: Maybe<CurrentUser>;
  feed?: Maybe<Feed>;
  investmentIdeas?: Maybe<Ideas>;
  investmentRegistry?: Maybe<InvestmentRegistry>;
  limited?: Maybe<Limited>;
  statements?: Maybe<Statements>;
  stocks?: Maybe<StocksQuery>;
  tariff: StockTariff;
  unlimited?: Maybe<Unlimited>;
};

export type RussianBankingDetail = {
  __typename?: 'RussianBankingDetail';
  accountNumber: Scalars['String'];
  bankCorrespondentAccount?: Maybe<Scalars['String']>;
  bankName: Scalars['String'];
  beneficiaryINN: Scalars['String'];
  bic: Scalars['String'];
  /** ISO local date */
  birthday?: Maybe<Scalars['String']>;
  clientHomeAddress: Scalars['String'];
  clientName: Scalars['String'];
};

export type Sort = {
  direction: SortDirection;
  property: Scalars['String'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

export enum SortDirectionV2 {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type SortFieldV2 = {
  /** if null - ASC */
  direction?: Maybe<SortDirectionV2>;
  fieldName: Scalars['String'];
};

export type Statements = {
  __typename?: 'Statements';
  tradingBalance?: Maybe<MoneyV2>;
  /** [effectively not null] */
  withdrawRequestOperations?: Maybe<Array<StatementsWithdrawRequestOperation>>;
};

export type StatementsTradingBalanceArgs = {
  market?: Maybe<StatementsMarket>;
};

export type StatementsWithdrawRequestOperationsArgs = {
  market: StatementsMarket;
};

export enum StatementsMarket {
  UsEquities = 'UsEquities',
  UsEquitiesDemo = 'UsEquitiesDemo',
  Utex = 'Utex',
  UtexDemo = 'UtexDemo',
}

/**  Создание операции вывода  */
export type StatementsWithdrawRequestCreated = {
  __typename?: 'StatementsWithdrawRequestCreated';
  /**  Сумма  */
  amount?: Maybe<MoneyV2>;
  /**  Дата запроса на вывод средств  */
  created?: Maybe<Scalars['ZonedDateTime']>;
  /**  id-ник при создании операции вывода  */
  id: Scalars['ID'];
  /**  Маркет  */
  market: StatementsMarket;
  /**  Статус WithdrawRequestStatus.Created  */
  status: StatementsWithdrawRequestStatus;
};

/**  Операция вывода  */
export type StatementsWithdrawRequestOperation =
  | StatementsWithdrawRequestCreated
  | StatementsWithdrawRequestRejected;

/**  Отказ по операции вывода  */
export type StatementsWithdrawRequestRejected = {
  __typename?: 'StatementsWithdrawRequestRejected';
  /**  Сумма  */
  amount?: Maybe<MoneyV2>;
  /**  Дата запроса на вывод средств  */
  created?: Maybe<Scalars['ZonedDateTime']>;
  /**  Причина отказа  */
  description?: Maybe<Scalars['String']>;
  /**  id-ник при создании операции вывода  */
  id: Scalars['ID'];
  /**  Маркет  */
  market: StatementsMarket;
  /**  Статус WithdrawRequestStatus.Rejected  */
  status: StatementsWithdrawRequestStatus;
  /**  Дата отказа по операции вывода  */
  updated?: Maybe<Scalars['ZonedDateTime']>;
};

/**  Статусы по операции ввода  */
export enum StatementsWithdrawRequestStatus {
  Created = 'Created',
  Rejected = 'Rejected',
}

export type StockListFilterV2 = {
  capitalizationFrom?: Maybe<MoneyInputV2>;
  capitalizationTo?: Maybe<MoneyInputV2>;
  industry?: Maybe<Scalars['String']>;
  risk?: Maybe<StockRiskV2>;
  searchString?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  type?: Maybe<StockTypeV2>;
};

export enum StockRiskV2 {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export enum StockStatusV2 {
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED',
}

/**
 * Комиссия - feePercent от суммы ордера,
 * но не меньше minFee и не больше maxFee
 */
export type StockTariff = {
  __typename?: 'StockTariff';
  feePercent: Scalars['Float'];
  maxFee: Money;
  minFee: Money;
};

export enum StockTypeV2 {
  Etf = 'ETF',
  Stocks = 'STOCKS',
}

export type StockV2 = {
  __typename?: 'StockV2';
  buyDisabled: Scalars['Boolean'];
  capitalization: MoneyV2;
  /** Акция или ETF */
  category: Scalars['String'];
  /** Используются дневные свечи */
  chart: StocksChartV2;
  /** Deprecated, use StocksQuery.tariff */
  fees: StocksFeeV2;
  /** Глобальный UUID акции */
  id: Scalars['ID'];
  industry: Scalars['String'];
  logoUrl: Scalars['String'];
  marketData: StocksMarketDataV2;
  minAmount: MoneyV2;
  minSellQty: Scalars['Float'];
  /** Международное название компании на английском, например ABBVIE INC */
  name: Scalars['String'];
  /** Целочисленный идентификатор акции, локальный для сервиса investment-stocks */
  numericId: Scalars['Int'];
  /**
   * информация о комиссиях при покупке (зависит от кол-ва акций)
   * null при ошибках на бэкенде
   */
  preparedBuyInfo?: Maybe<StocksPreparedBuyInfoV2>;
  qtyStep: Scalars['Float'];
  riskLevel: StockRiskV2;
  sector: Scalars['String'];
  sellDisabled: Scalars['Boolean'];
  /** Опубликована или скрыта */
  status: StockStatusV2;
  ticker: Scalars['String'];
  /** Переведённое (местами) название компании, например AbbVie, Inc. */
  title: Scalars['String'];
  type: StockTypeV2;
};

export type StockV2ChartArgs = {
  request: StocksChartRequestV2;
};

export type StockV2PreparedBuyInfoArgs = {
  request: StocksPreparedBuyInfoRequestV2;
};

export type StockV2TitleArgs = {
  locale: Scalars['String'];
};

export type StocksBuyOrderFeeV2 = {
  __typename?: 'StocksBuyOrderFeeV2';
  enterFee: MoneyV2;
};

export type StocksChartPointV2 = {
  __typename?: 'StocksChartPointV2';
  close: Scalars['Float'];
  date: Scalars['ZonedDateTime'];
  high: Scalars['Float'];
  low: Scalars['Float'];
  open: Scalars['Float'];
  volume: Scalars['Float'];
};

export type StocksChartRequestV2 = {
  from: Scalars['ZonedDateTime'];
  to: Scalars['ZonedDateTime'];
};

export type StocksChartV2 = {
  __typename?: 'StocksChartV2';
  points: Array<StocksChartPointV2>;
};

/** Deprecated - use StocksTariffV2 */
export type StocksFeeV2 = {
  __typename?: 'StocksFeeV2';
  enterFee: MoneyV2;
  leaveFee: MoneyV2;
};

export type StocksMarketDataV2 = {
  __typename?: 'StocksMarketDataV2';
  /** цена по которой юзер может купить */
  ask?: Maybe<MoneyV2>;
  /** цена по которой юзер может продать */
  bid?: Maybe<MoneyV2>;
};

export type StocksOrderExecutedPartV2 = {
  __typename?: 'StocksOrderExecutedPartV2';
  /**
   * Движение по средств по счету с учётом всех комиссий.
   * Для свежесозданного BUY|SELL = 0.
   * Для частично или полностью исполненного BUY - сумма, списанная со счёта пользователя,
   * с учётом того, что часть зарезервированных денег почти всегда возвращается.
   * Для частично или полностью исполненного SELL - сумма, пришедшая на счёт пользователя.
   */
  accountMovement: MoneyV2;
  /** средневзвешенная цена исполнения по этому ордеру */
  executedPrice: MoneyV2;
  /** комиссии которые взяты с пользователя (начислены на соответствующие счета в биллинге) */
  fees: StocksOrderFeeV2;
  qty: Scalars['Float'];
};

export type StocksOrderFeeV2 = StocksBuyOrderFeeV2 | StocksSellOrderFeeV2;

export type StocksOrderNotExecutedPartV2 = {
  __typename?: 'StocksOrderNotExecutedPartV2';
  /**
   * Движение средств по счету с учётом всех комиссий.
   * Для свежесозданного BUY - cумма, которую investment зарезервировал в биллинге,
   * и которая вернется на счет в случае отмены ордера.
   * Для свежесозданного SELL - минимальная сумма, которую пользователь получит
   * в случае исполнения ордера по лимитной цене.
   * Для частично или полностью исполненного BUY|SELL = 0.
   */
  accountMovement: MoneyV2;
  /**
   * в случае если ордер REJECT = 0.
   * Если Open - сумма комиссии, которую мы возьмем с пользователя
   * Ecли Filled -  0
   */
  fees: StocksOrderFeeV2;
  /**
   * Кол-во акций, которого не хватает до полного исполнения ордера.
   * В свежесозданном ордере - сколько акций запросил пользователь.
   * В исполненном ордере - сколько акций биржа недодала, почти всегда это ноль.
   */
  qty: Scalars['Float'];
};

export type StocksOrderRejectReasonV2 = {
  __typename?: 'StocksOrderRejectReasonV2';
  /** ключ локализации или свободное сообщение */
  code: Scalars['String'];
  /** параметры для локализации формализованного сообщения */
  params?: Maybe<Array<Maybe<MapItem>>>;
};

export enum StocksOrderStatusV2 {
  Filled = 'FILLED',
  Opened = 'OPENED',
  Rejected = 'REJECTED',
  RejectedAndAcknowledged = 'REJECTED_AND_ACKNOWLEDGED',
}

export type StocksOrderV2 = {
  __typename?: 'StocksOrderV2';
  card: StocksUserCardV2;
  createdDate: Scalars['ZonedDateTime'];
  executedPart: StocksOrderExecutedPartV2;
  id: Scalars['ID'];
  /** Если по ордеру не было ни одного сведения - равна createdDate */
  lastExecutionDate: Scalars['ZonedDateTime'];
  notExecutedPart: StocksOrderNotExecutedPartV2;
  /** Цена акции для пользователя (со всеми запасами) на момент подачи */
  price: MoneyV2;
  rejectDate?: Maybe<Scalars['ZonedDateTime']>;
  rejectReason?: Maybe<StocksOrderRejectReasonV2>;
  side: StocksSideV2;
  status: StocksOrderStatusV2;
};

export type StocksOrdersFilterV2 = {
  sides?: Array<StocksSideV2>;
  statuses?: Array<Scalars['String']>;
};

export type StocksPagedResponse = PagedResponseV2 & {
  __typename?: 'StocksPagedResponse';
  content: Array<StockV2>;
  pageInfo: PageInfoV2;
};

export type StocksPositionsSummary = {
  __typename?: 'StocksPositionsSummary';
  /** сколько денег списали с основного счета биллинга для открытых позиций за вычетом комиссий */
  grossUnrealizedPnlSum: MoneyV2;
  investmentSum: MoneyV2;
};

export type StocksPreparedBuyInfoRequestV2 = {
  qty: Scalars['Float'];
};

export type StocksPreparedBuyInfoV2 = {
  __typename?: 'StocksPreparedBuyInfoV2';
  enterFee: MoneyV2;
  toBeReservedFromAccount: MoneyV2;
};

export type StocksPreparedSellInfoRequestV2 = {
  qty: Scalars['Float'];
};

export type StocksPreparedSellInfoV2 = {
  __typename?: 'StocksPreparedSellInfoV2';
  leaveFee: MoneyV2;
  toBeTransferredToAccount: MoneyV2;
};

export type StocksQuery = {
  __typename?: 'StocksQuery';
  positionsSummary?: Maybe<StocksPositionsSummary>;
  stock?: Maybe<StockV2>;
  stocks: StocksPagedResponse;
  tariff?: Maybe<StocksTariffV2>;
  userCard?: Maybe<StocksUserCardV2>;
  userCards?: Maybe<Array<StocksUserCardV2>>;
  workingHours?: Maybe<StocksWorkingHours>;
};

export type StocksQueryStockArgs = {
  id: Scalars['ID'];
};

export type StocksQueryStocksArgs = {
  filter?: Maybe<StockListFilterV2>;
  pageRequest?: Maybe<PageRequestV2>;
};

export type StocksQueryUserCardArgs = {
  id: Scalars['ID'];
};

export type StocksQueryUserCardsArgs = {
  request: StocksUserCardsRequestV2;
};

export type StocksQueryWorkingHoursArgs = {
  request?: Maybe<StocksWorkingHoursRequest>;
};

export type StocksSellOrderFeeV2 = {
  __typename?: 'StocksSellOrderFeeV2';
  leaveFee: MoneyV2;
};

export enum StocksSideV2 {
  Buy = 'Buy',
  Sell = 'Sell',
}

/**
 * Комиссия - feePercent от суммы ордера,
 * но не меньше minFee и не больше maxFee
 */
export type StocksTariffV2 = {
  __typename?: 'StocksTariffV2';
  feePercent: Scalars['Percent'];
  maxFee: MoneyV2;
  minFee: MoneyV2;
};

export type StocksUserCardV2 = {
  __typename?: 'StocksUserCardV2';
  /**
   * Актуальный InvestAmount для отображения пользователю
   *
   * Есть 3 кейса:
   *   Если это карточка заявки (hasFilledOrders = false)
   *   сумма buy-ордеров в статусах OPENED, REJECTED
   *
   *   Если карточка с незавершенной позицией (hasFilledOrders = true, PositionQty ≠ 0)
   *   сумма InitialPositionValue
   *
   *   Если карточка завершенной позиции (hasFilledOrders = true, positionQty = 0)
   *   debitedFromAccount (или как оно там называется)
   */
  actualInvestedAmount: MoneyV2;
  /**
   * Актуальный Pnl для отображения пользователю
   *
   * Есть 3 кейса:
   *   Если это карточка заявки (hasFilledOrders = false)
   *   grossUnrealizedPnl (который фактически всегда 0 пока)
   *
   *   Если карточка с незавершенной позицией (hasFilledOrders = true, PositionQty ≠ 0)
   *   grossUnrealizedPnl
   *
   *   Если карточка завершенной позиции (hasFilledOrders = true, positionQty = 0)
   *   netRealizedPnl
   */
  actualPnl: MoneyV2;
  /** Актуальный PnlPercent для отображения пользователю */
  actualPnlPercent: Scalars['Percent'];
  /** дата и время архивации карточки. Для сортировки в архиве */
  archivedDate?: Maybe<Scalars['ZonedDateTime']>;
  /** дата и время создания карточки. Для правильной сортировки */
  creationDate: Scalars['ZonedDateTime'];
  /** текущая стоимость позиции */
  currentPositionValue: MoneyV2;
  /** сумма исполненных ордеров(buy) + ордеров в ожидании с учетом комиссии; */
  debitedFromAccount: MoneyV2;
  grossUnrealizedPnl: MoneyV2;
  grossUnrealizedPnlPercent: Scalars['Percent'];
  /** флаг наличия ордеров в статусе FILLED */
  hasFilledOrders: Scalars['Boolean'];
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
  /** дата и время последних изменений в карточке. Для правильной сортировки */
  lastActivityDate: Scalars['ZonedDateTime'];
  netRealizedPnl: MoneyV2;
  netRealizedPnlPercent: Scalars['Percent'];
  orders: Array<StocksOrderV2>;
  positionQty: Scalars['Float'];
  /**
   * Актуальное количество инструмента в позиции по ценам покупки.
   * Допустим: первоначально позиция была открыта с 3 акциями по 10 USD каждая.
   * Потом продали 1 акцию. Значит это поле будет отражать: 2 * 10 USD.
   */
  positionValueByInitialPrices: MoneyV2;
  /**
   * информация о комиссиях перед выводом (зависит от кол-ва акций которые выбирает юзер)
   * null при ошибках на бэкенде
   */
  preparedSellInfo?: Maybe<StocksPreparedSellInfoV2>;
  stock: StockV2;
  /** сумма всех исполененных продаж(sell) с учетом комиссий */
  transferredToAccount: MoneyV2;
};

export type StocksUserCardV2OrdersArgs = {
  filter: StocksOrdersFilterV2;
};

export type StocksUserCardV2PreparedSellInfoArgs = {
  request: StocksPreparedSellInfoRequestV2;
};

export type StocksUserCardsRequestV2 = {
  /** В случае если isArchived == true возвращаются карточки с флагом hasFilledOrders == true */
  isArchived?: Maybe<Scalars['Boolean']>;
};

export type StocksWorkingHours = {
  __typename?: 'StocksWorkingHours';
  from: Scalars['ZonedDateTime'];
  isOnline: Scalars['Boolean'];
  to: Scalars['ZonedDateTime'];
};

export type StocksWorkingHoursRequest = {
  /** null означает "сейчас" */
  dateTime?: Maybe<Scalars['ZonedDateTime']>;
};

export type Unlimited = {
  __typename?: 'Unlimited';
  idea?: Maybe<UnlimitedIdeaV2>;
  ideas: Array<UnlimitedIdeaV2>;
  positionsSummary?: Maybe<UnlimitedPositionsSummary>;
  userCard?: Maybe<UnlimitedUserCardV2>;
  userCards?: Maybe<Array<UnlimitedUserCardV2>>;
};

export type UnlimitedIdeaArgs = {
  id: Scalars['ID'];
};

export type UnlimitedIdeasArgs = {
  filter?: UnlimitedIdeasFilter;
};

export type UnlimitedUserCardArgs = {
  id: Scalars['ID'];
};

export type UnlimitedUserCardsArgs = {
  request?: UnlimitedUserCardsRequestV2;
};

export enum UnlimitedBillingPeriod {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
}

export type UnlimitedBuyOrderFeeV2 = {
  __typename?: 'UnlimitedBuyOrderFeeV2';
  enterFee: MoneyV2;
  enterFeePercent: Scalars['Percent'];
};

export type UnlimitedIdeaFeeV2 = {
  __typename?: 'UnlimitedIdeaFeeV2';
  enterFeePercent: Scalars['Percent'];
  managementFeePercent: Scalars['Percent'];
  successFeePercent: Scalars['Percent'];
};

export enum UnlimitedIdeaRiskLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export type UnlimitedIdeaV2 = {
  __typename?: 'UnlimitedIdeaV2';
  billingPeriod: UnlimitedBillingPeriod;
  category: Scalars['String'];
  /** depends on Accept-Language http header */
  descriptionLocalized: Scalars['String'];
  fees?: Maybe<UnlimitedIdeaFeeV2>;
  /** depends on Accept-Language http header */
  fullDescriptionLocalized: Scalars['String'];
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
  /** Порядок идеи в публичном списке всех идей (глобально уникален в рамках limited, unlimited, bnh). Чем больше число - тем выше должна быть идея в списке. */
  listIndex: Scalars['Long'];
  logoUrl: Scalars['String'];
  minAmount: MoneyV2;
  name: Scalars['String'];
  /** дата следующего старта, завивисит от billingPeriod */
  nextStart: Scalars['ZonedDateTime'];
  /** прогнозируемый доход */
  profit: Scalars['Percent'];
  riskLevel: UnlimitedIdeaRiskLevel;
  ticker?: Maybe<Scalars['String']>;
};

export type UnlimitedIdeaV2FeesArgs = {
  amount: MoneyInputV2;
};

export type UnlimitedIdeasFilter = {
  categories?: Maybe<Array<Scalars['String']>>;
};

export type UnlimitedOrderExecutedPartV2 = {
  __typename?: 'UnlimitedOrderExecutedPartV2';
  accountMovement: MoneyV2;
  amount: MoneyV2;
  fees: UnlimitedOrderFeeV2;
};

export type UnlimitedOrderFeeV2 = UnlimitedBuyOrderFeeV2 | UnlimitedSellOrderFeeV2;

export type UnlimitedOrderNotExecutedPartV2 = {
  __typename?: 'UnlimitedOrderNotExecutedPartV2';
  accountMovement: MoneyV2;
  amount: MoneyV2;
  /** предполагаемая коммиссия */
  fees: UnlimitedOrderFeeV2;
};

export type UnlimitedOrderRejectReasonV2 = {
  __typename?: 'UnlimitedOrderRejectReasonV2';
  /** ключ локализации или свободное сообщение */
  code: Scalars['String'];
  /** параметры для локализации формализованного сообщения */
  params?: Maybe<Array<Maybe<MapItem>>>;
};

export enum UnlimitedOrderSideV2 {
  Buy = 'Buy',
  Sell = 'Sell',
}

export enum UnlimitedOrderStatusV2 {
  Cancelled = 'CANCELLED',
  Filled = 'FILLED',
  Opened = 'OPENED',
  Rejected = 'REJECTED',
  RejectedAndAcknowledged = 'REJECTED_AND_ACKNOWLEDGED',
}

export type UnlimitedOrderV2 = {
  __typename?: 'UnlimitedOrderV2';
  card: UnlimitedUserCardV2;
  createdDate: Scalars['ZonedDateTime'];
  executedPart: UnlimitedOrderExecutedPartV2;
  id: Scalars['ID'];
  idea: UnlimitedIdeaV2;
  /** Если по ордеру не было ни одного сведения - равна createdDate */
  lastExecutionDate: Scalars['ZonedDateTime'];
  notExecutedPart: UnlimitedOrderNotExecutedPartV2;
  rejectDate?: Maybe<Scalars['ZonedDateTime']>;
  rejectReason?: Maybe<UnlimitedOrderRejectReasonV2>;
  side: UnlimitedOrderSideV2;
  status: UnlimitedOrderStatusV2;
};

export type UnlimitedOrdersFilterV2 = {
  /** if empty list == fetch all sides */
  sides?: Maybe<Array<UnlimitedOrderSideV2>>;
  /** if empty list == fetch all statuses */
  statuses?: Maybe<Array<UnlimitedOrderStatusV2>>;
};

export type UnlimitedPositionsSummary = {
  __typename?: 'UnlimitedPositionsSummary';
  /** нереализованная прибыль/убыток по всем открытым позициям */
  grossUnrealizedPnlSum: MoneyV2;
  /** сколько денег списали с основного счета биллинга для открытых позиций за вычетом комиссий */
  investmentSum: MoneyV2;
};

export type UnlimitedPreparedEarlyLeaveInfo = {
  __typename?: 'UnlimitedPreparedEarlyLeaveInfo';
  managementFee: MoneyV2;
  netUnrealizedPnl: MoneyV2;
  successFee: MoneyV2;
  toBeTransferredToAccount: MoneyV2;
};

export type UnlimitedPreparedOnTimeLeaveInfo = {
  __typename?: 'UnlimitedPreparedOnTimeLeaveInfo';
  managementFee: MoneyV2;
  netUnrealizedPnl: MoneyV2;
  successFee: MoneyV2;
  toBeTransferredToAccount: MoneyV2;
};

export type UnlimitedSellOrderFeeV2 = {
  __typename?: 'UnlimitedSellOrderFeeV2';
  managementFee: MoneyV2;
  managementFeePercent: Scalars['Percent'];
  successFee: MoneyV2;
  successFeePercent: Scalars['Percent'];
};

export type UnlimitedUserCardV2 = {
  __typename?: 'UnlimitedUserCardV2';
  /** Актуальный InvestAmount для отображения пользователю */
  actualInvestedAmount: MoneyV2;
  /** Актуальный Pnl для отображения пользователю */
  actualPnl: MoneyV2;
  /** Актуальный PnlPercent для отображения пользователю */
  actualPnlPercent: Scalars['Percent'];
  /** дата и время архивации карточки. Для сортировки в архиве */
  archivedDate?: Maybe<Scalars['ZonedDateTime']>;
  /** дата и время создания карточки. Для правильной сортировки */
  creationDate: Scalars['ZonedDateTime'];
  /** текущая стоимость позиции */
  currentPositionValue: MoneyV2;
  /** сумма исполненных ордеров(buy) + ордеров в ожидании с учетом комиссии; */
  debitedFromAccount: MoneyV2;
  grossUnrealizedPnl: MoneyV2;
  grossUnrealizedPnlPercent: Scalars['Percent'];
  /** флаг наличия ордеров в статусе FILLED */
  hasFilledOrders: Scalars['Boolean'];
  /** новая сущность на бекенде */
  id: Scalars['ID'];
  idea: UnlimitedIdeaV2;
  /** стоимость позиции по ценам покупок */
  initialPositionValue: MoneyV2;
  isArchived: Scalars['Boolean'];
  /** дата и время последних изменений в карточке. Для правильной сортировки */
  lastActivityDate: Scalars['ZonedDateTime'];
  netRealizedPnl: MoneyV2;
  netRealizedPnlPercent: Scalars['Percent'];
  orders: Array<UnlimitedOrderV2>;
  /** информация о комиссиях перед ранним выводом */
  preparedEarlyLeaveInfo?: Maybe<UnlimitedPreparedEarlyLeaveInfo>;
  /** информация о комиссиях перед штатным выходом */
  preparedOnTimeLeaveInfo?: Maybe<UnlimitedPreparedOnTimeLeaveInfo>;
  /** сумма всех исполененных продаж(sell) с учетом комиссий */
  transferredToAccount: MoneyV2;
};

export type UnlimitedUserCardV2OrdersArgs = {
  filter?: Maybe<UnlimitedOrdersFilterV2>;
};

export type UnlimitedUserCardsRequestV2 = {
  /** В случае если isArchived == true, возвращаются карточки с флагом isArchived == true, у которых флаг hasFilledOrders == true */
  isArchived?: Scalars['Boolean'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['String'];
};

export type UserInfo = {
  __typename?: 'UserInfo';
  avatarUrl?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  login: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export enum UserOtpType {
  OtpDisabled = 'OTP_DISABLED',
  OtpEmail = 'OTP_EMAIL',
  OtpGa = 'OTP_GA',
}

export type UtexBalance = {
  __typename?: 'UtexBalance';
  currency?: Maybe<Currency>;
  reserved: Scalars['Long'];
  reservedHumanReadable: MoneyV2;
  total: Scalars['Long'];
  totalHumanReadable: MoneyV2;
  userId: Scalars['String'];
};

export type WithdrawDetail = {
  __typename?: 'WithdrawDetail';
  content: WithdrawDetailContent;
  id: Scalars['Long'];
  status: WithdrawDetailState;
  type: DetailType;
};

export type WithdrawDetailContent =
  | AbroadBankingDetail
  | AlfaBankAccountDetail
  | CardDetail
  | CryptoDetail
  | ProviderWalletDetail
  | RussianBankingDetail;

export enum WithdrawDetailState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}

export type WithdrawRequestPage = {
  __typename?: 'WithdrawRequestPage';
  content: Array<ClearingWithdrawRequest>;
  number: Scalars['Int'];
  size: Scalars['Int'];
  totalElements: Scalars['Long'];
  totalPages: Scalars['Int'];
};

export type WithdrawRequestPageInput = {
  direction?: Maybe<Direction>;
  /** 0 is first page. */
  number: Scalars['Int'];
  /** Max items count per page. Valid values are in 1..1000; any other value is considered as 1000 */
  size: Scalars['Int'];
  sortingField?: Maybe<WithdrawRequestSortingField>;
};

export enum WithdrawRequestSortingField {
  Amount = 'AMOUNT',
  Commission = 'COMMISSION',
  /** use by default */
  Id = 'ID',
  Product = 'PRODUCT',
  Status = 'STATUS',
}

export enum WithdrawRequestStatus {
  AntiFraudReviewing = 'ANTI_FRAUD_REVIEWING',
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Published = 'PUBLISHED',
  Rejected = 'REJECTED',
  Reserved = 'RESERVED',
}
